import { isMobileOnly } from 'react-device-detect';

export const isMobile = isMobileOnly;

export const calendar1150 = window.innerWidth < 1150;
